var map = {
	"./atosa.webp": 6068,
	"./blizzard.webp": 7800,
	"./electrolux.webp": 8383,
	"./fagor.webp": 8541,
	"./foster.webp": 3649,
	"./gram.webp": 3421,
	"./hoshizaki.webp": 7306,
	"./infrico.webp": 3050,
	"./polar.webp": 4658,
	"./scotsman.webp": 8328,
	"./tefcold.webp": 447,
	"./true.webp": 6814,
	"./williams.webp": 8376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5806;